import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.resize()
    window.addEventListener('resize', this.resize.bind(this))
  }

  disconnect() {
    window.removeEventListener('resize', this.resize.bind(this))
  }

  resize() {
    const outerDiv = this.element
    if (outerDiv) {
      outerDiv.style.height = `${window.innerHeight}px`
    }
  }
}

